import type { ContentData, ContentType, VariableDef } from "@/api/content";
import { ChecklistEditor } from "./ChecklistEditor";
import { ContactCardEditor } from "./ContactCardEditor";
import { LinkEditor } from "./LinkEditor";
import { MarkdownContentEditor } from "./MarkdownContentEditor";
import { VideoEditor } from "./VideoEditor";
import { WorkflowEditor } from "./WorkflowEditor";

/** Dispatches to the authoring editor that matches the module's content_type. */
export function ContentEditor({
  type,
  moduleId,
  content,
  onChange,
  variables,
}: {
  type: ContentType;
  moduleId: string;
  content: ContentData;
  onChange: (next: ContentData) => void;
  variables: VariableDef[];
}) {
  switch (type) {
    case "document":
    case "rule":
      return <MarkdownContentEditor moduleId={moduleId} content={content} onChange={onChange} variables={variables} />;
    case "workflow":
      return <WorkflowEditor content={content} onChange={onChange} />;
    case "checklist":
      return <ChecklistEditor content={content} onChange={onChange} />;
    case "contact_card":
      return <ContactCardEditor content={content} onChange={onChange} />;
    case "video":
      return <VideoEditor content={content} onChange={onChange} />;
    case "link":
      return <LinkEditor content={content} onChange={onChange} />;
  }
}
